import React, {useEffect, useState} from 'react';

const PriceItemList = (props) => {
  return (
    <div className='price-item-list-wrapper'>
      <div className='section-wrapper'>
        <div className='section-title'> חיובים חודשיים </div>
        <div className='section-details'>
        {props.summaryDetails.shoppingCart.orderPrices?.map((order, index) => {
        return(<>
        {order.offerItemList?.map((priceItem, index) => {
            return (
              <div className='details-row' key={index}>
                <div className='title-wrapper'>
                  {props.summaryDetails.offerName} {priceItem.priceText}
                </div>
                <div className='price-wrapper'>
                  <span className='price'>
                    {displayPrice(priceItem.price)}
                    <span className='nis'>₪</span>
                  </span>
                </div>
              </div>
            )})}
            {order.addonsPrices?.map((addon, index) => {
            return addon.priceItemList?.map((priceItem, index) => {
              return (
                <div className='details-row' key={index}>
                  <div className='title-wrapper'>
                    <span className='product-name'><span>{addon.title}</span> <span>{priceItem.priceText}</span></span>
                  </div>
                  <div className='price-wrapper'>
                    <span className='price'>
                      {displayPrice(priceItem.price)}
                      <span className='nis'>₪</span>
                    </span>
                  </div>
                </div>
              )
            })
          })}
          </>)
          })}

          <div className='summary-row'>
            {props.summaryDetails.shoppingCart.fullPrice?.map((priceItem, index) => {
              return (
                <div className='details-row' key={index}>
                  <div className='title-wrapper'>סה"כ {priceItem.priceText}</div>
                  <div className='price-wrapper'>
                    <span className='price'>
                      {displayPrice(priceItem.price)}
                      <span className='nis'>₪</span>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </div>

      {(props.summaryDetails?.oneTimePriceList?.length > 0 || props.summaryDetails?.premiumPackagesVasList?.length > 0) && (
        <div className='section-wrapper'>
          <div className='section-title'> חיוביים חד פעמיים </div>
          <div className='section-details'>
            {props.summaryDetails.oneTimePriceList.map((item, index) => {
              return (
                <div className='details-row' key={index}>
                  <div className='title-wrapper' dangerouslySetInnerHTML={{__html: item.name}}></div>
                  <div className='price-wrapper'>
                    <span className='price'>
                      {displayPrice(item.price)}
                      <span className='nis'>₪</span>
                    </span>
                  </div>
                </div>
              );
            })}

            <div className='summary-row'>
              <div className='details-row'>
                <div className='title-wrapper'>סה"כ חיוב חד פעמי</div>
                <div className='price-wrapper'>
                  <span className='price'>
                    {displayPrice(props.summaryDetails.totalPriceOneTime)}
                    <span className='nis'>₪</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  function displayPrice(price) {
    if (typeof price === 'number') {
      return parseFloat(price.toFixed(2));
    } else {
      return parseFloat(parseFloat(price).toFixed(2));
    }
  }
};
export default PriceItemList;
